import React from "react";
import { Card, CardContent, CardMedia, Typography, Box } from "@mui/material";
import cvoImage from "assets/bike_stock_images/cvo.jpg";
import nightsterImage from "assets/bike_stock_images/nightster.jpg";
import panAmImage from "assets/bike_stock_images/pan am.jpg";
import sportsterImage from "assets/bike_stock_images/sportster.jpg";
import touringImage from "assets/bike_stock_images/touring.jpg";
import trikeImage from "assets/bike_stock_images/trike.jpg";
import livewire from "assets/bike_stock_images/livewire.jpg";
import triGlideImage from "assets/bike_stock_images/tri glide.jpg";
import roadGlideImage from "assets/bike_stock_images/road glide.jpg";
import heritageClassicImage from "assets/bike_stock_images/heritage classic.jpg";
import {useIsMobile} from "hooks/useIsMobile";
/**
 * MotorcycleCard Component
 * @param {Object} unit - Motorcycle data
 * @returns {React.ReactElement} Motorcycle card element
 */
const MotorcycleCard = ({ unit }) => {
  const { year, make, model, vin } = unit;
  const isMobile = useIsMobile();
  const standardizedModel = model.toLowerCase();

  // Determine the appropriate image based on the model name
  const getModelImage = () => {
    if (standardizedModel.includes("cvo")) {
      return cvoImage;
    }
    if (standardizedModel.includes("nightster")) {
      return nightsterImage;
    }
    if (standardizedModel.includes("pan am")) {
      return panAmImage;
    }
    if (standardizedModel.includes("sportster")) {
      return sportsterImage;
    }
    if (standardizedModel.includes("touring")) {
      return touringImage;
    }
    if (standardizedModel.includes("trike")) {
      return trikeImage;
    }
    if (standardizedModel.includes("ev1")) {
      return livewire;
    }
    if (standardizedModel.includes("tri glide")) {
      return triGlideImage;
    }
    if (standardizedModel.includes("road glide")) {
      return roadGlideImage;
    }
    if (standardizedModel.includes("heritage classic")) {
      return heritageClassicImage;
    }
    return cvoImage;
  };

  console.log(standardizedModel)

  const modelImage = getModelImage();

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: { xs: "row", sm: "column" }, // Row for mobile, column for larger screens
        alignItems: "center",
        padding: 2,
        gap: 2,
        maxWidth: 345,
        marginBottom: 3,
      }}
    >
      <CardMedia
        component="img"
        sx={{
          width: { xs: 100, sm: "100%" }, // Smaller width on mobile
          height: { xs: 100, sm: 240 }, // Proportional height
          borderRadius: 2,
          objectFit: "contain",
          objectPosition: "center", // Centers the image inside the container
        }}

        image={modelImage}
        alt={`${make} motorcycle`}
      />
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: 1,
          textAlign: { xs: "left", sm: "center" }, // Align text left on mobile
        }}
      >
        <Typography variant="h6" component="div">
          {`${year} ${make}`}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Model: {model}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          VIN: {vin}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default MotorcycleCard;
